<template>
  <div>
    <div v-if="track">
      <div class="h-100 w-100 flex">
        <div class="pointer h-100 w-79 flex flex-column bg-primary resize">
          <div class="fl ma0 items-center justify-between">
            <div class="image-container">
              <img class="image-container h-100 w-70" :src="trackPicture">
            </div>
          </div>
          <p class="track-container title fl h-100 pa1 pr3 ma0 text-ellipsis center-content textColor trackTitle">{{ track.title }}</p>
          <router-link :to="{ name:'artist-info', params:{ id:track.id_artist }}" append @click.native.stop class="textColor no-underline">
            <p v-if="track.artist" class="track-container artist fl h-100 pa1 ma0 text-ellipsis center-content textColor artistName">{{ track.artist.name }}</p>
            <p v-if="track.name" class="track-container artist fl h-100 pa1 ma0 text-ellipsis center-content textColor artistName">{{ track.name }}</p>
          </router-link>
          <p v-if="track.genre" class="track-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor genreNameAndTime">{{ track.genre.name }}</p>
          <p v-if="track.music_type" class="track-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor genreNameAndTime">{{ track.music_type }}</p>
          <p class="track-container released fl h-100 pa1 ma0 center-content textColor genreNameAndTime">{{ this.trackTime }}</p>
          <!-- <track-options-button v-if="isMyFavorites" :track="track" :inMyLikes="isMyFavorites" class="ma0 textColor"/> -->
          <track-options-button :track="track" :inMyLikes="true" class="ma0 textColor"/>
        </div>
      </div>
    </div>
    <div v-if="playlist">
      <div class="h-100 w-100 flex">
        <div class="pointer h-100 w-79 flex flex-column bg-primary minH-220">
          <div class="fl ma0 items-center justify-between">
            <div class="image-container">
              <img class="image-container h-100 w-100" :src="playlistPicture">
            </div>
          </div>
          <p class="track-container title fl h-100 pa1 pr3 ma0 text-ellipsis center-content textColor">{{ playlist.title }}</p>
          <p class="track-container genre fl h-100 pa1 ma0 text-ellipsis center-content textColor">{{ playlist.user.user_name }}</p>
          <button v-if="!isMyPlaylists" @click="likePlaylist()" class="like-button pa2 iconColor" :title="$t('playlists.like.button')">
            <font-awesome-icon :class="liking ? 'liked' : 'iconColor'" icon="heart"/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TrackOptionsButton from '@/components/tracks/TrackOptionsButton.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import consts from '@/consts'

  export default {
    name: 'carousel-item',
    props: {
      track: {
        default: false
      },
      playlist: {
        default: false
      },
      isMyFavorites: {
        default: false
      },
      isMyPlaylists: {
        default: false
      }
    },
    data () {
      return {
        trackTime: null,
        liking: null
      }
    },
    components: {
      TrackOptionsButton,
      FontAwesomeIcon
    },
    computed: {
      ...mapGetters('player', [
        'currentTrack',
        'isPlaying'
      ]),
      ...mapGetters('track', [
        'loading',
        'allTracks'
      ]),
      ...mapGetters('playlist', [
        'playlistLiked'
      ]),
      trackPicture () {
        return consts.MEDIA_BASE_URL + this.track.picture
      },
      playlistPicture () {
        if (!this.playlist.picture) {
          return consts.BASE_HOST + '/static/assets/Img_comodines_Beathey_Playlist.jpg'
        }
        return consts.MEDIA_BASE_URL + this.playlist.picture
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaying',
        'changeTrack'
      ]),
      ...mapActions('playlist', [
        'togglePlaylistLike'
      ]),
      playTrack () {
        if (this.currentTrack !== this.track) {
          this.$emit('play')
          this.changeTrack(this.track)
        } else {
          this.setPlaying(true)
        }
      },
      trackTimeToMin () {
        let seg = this.track.seconds
        let min = 0
        this.trackTime = 0
        for (let i = 0; i < 60; i++) {
          if (seg >= 60) {
            min++
            seg -= 60
          } else if (seg < 60) {
            if (seg <= 9) {
              this.trackTime = (`${min}:0${seg}`)
              return this.trackTime
            } else {
              this.trackTime = (`${min}:${seg}`)
              return this.trackTime
            }
          }
        }
      },
      likePlaylist () {
        this.togglePlaylistLike(this.playlist.id).then(() => {
          this.liking = this.playlistLiked
        }).catch((e) => {
          // console.log('error')
          // console.log(e.message)
          // this.$toasted.show(this.error.message, {type: 'error'})
        })
      }
    },
    mounted () {
      this.trackTimeToMin()
      this.liking = this.playlist.liked
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .trackTitle {
    font-size: 13px;
    font-weight: bolder;
    text-transform: none;
  }

  .artistName {
    color: #E6007E;
    font-size: 12px;
    text-transform: none;
  }

  .genreNameAndTime {
    font-size: 12px;
    text-transform: none;
  }

  .center-content {
    line-height: normal;
  }

  .w-79 {
    width: 79%;
  }

  // .resize:hover {
  //   width: 190px;
  //   .image-container {
  //     width: 190px;
  //     height: 190px;
  //   }
  // }

  .play-pause-icon {
    margin-left: 10px;
  }

  .track-container{
    overflow-x: hidden;
  }

  .image-container {
    width: 150px;
    height: 150px;
  }

  .minH-316 {
    min-height: 316px;
  }
  .minH-280 {
    min-height: 280px;
  }
  .minH-220 {
    min-height: 220px;
  }
  .like-button{
    background-color: rgb(39, 39, 39);
    border: none;
    text-align: right;
    cursor: pointer;
  }
  .liked {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/carousel/CarouselItem.vue